import { takeLatest, call, put } from "redux-saga/effects";
import { getExpensesApiCall } from "./apiCalls";
import { getExpensesFailure, getExpensesPending, getExpensesSuccess } from "./actions";
import { GET_EXPENSES_REQUEST } from "./actionTypes";

function* getExpensesWorker({ payload }) {
  try {
    yield put(getExpensesPending());
    const response = yield call(getExpensesApiCall, payload);
    yield put(getExpensesSuccess(response.data.data));
  } catch (error) {
    console.log(error.message);
    yield put(getExpensesFailure({ error }));
  }
}

export function* expensesWatcher() {
  yield takeLatest(GET_EXPENSES_REQUEST, getExpensesWorker);
}
